import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Appointment from './pages/appointments/appointment';
import AppointmentEditor from './pages/appointments/appointment/edit';
import AppointmentCreator from './pages/appointments/appointment/create';
import AppointmentQuote from './pages/appointments/appointment/quote';
import CompanyEditor from './pages/companies/company/edit';
import CompanyCreator from './pages/companies/company/create';
import Settings from './pages/settings';
import Messages from './pages/messages';
import Login from './pages/login';
import Logout from './pages/logout';
import Register from './pages/register';
import Home from './pages/home';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import styled from 'styled-components';
import Layout from './components/layout';
import BareLayout from './components/layout/bare';
import Privacy from './pages/privacy';
import Terms from './pages/terms';
import AboutDeveloper from './pages/aboutDeveloper';
import Feedback from './pages/feedback';

import { Provider } from 'react-redux';
import { store } from './store';
import SimpleLayout from './components/layout/simple';
import './css/style.css';
import * as Sentry from '@sentry/react';

// Import the new components we'll create
import { SocketProvider } from './contexts/SocketContext';
import GlobalConnectionStatus from './components/GlobalConnectionStatus';
import PriceUpdateNotice from './components/PriceUpdateNotice';

// Sentry.init({
//   dsn: 'https://bb38b667267d5dc548b827be1d2e3024@o4507790505410560.ingest.de.sentry.io/4509360525410384',
//   sendDefaultPii: true,
//   environment: process.env.NODE_ENV,
//   _experiments: { enableLogs: true },
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.browserProfilingIntegration(),
//   ],
//   // Tracing
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: ['localhost', process.env.REACT_APP_IO_SERVER],
//   // Set profilesSampleRate to 1.0 to profile every transaction.
//   // Since profilesSampleRate is relative to tracesSampleRate,
//   // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
//   // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
//   // results in 25% of transactions being profiled (0.5*0.5=0.25)
//   profilesSampleRate: 1.0,
// });

const Container = styled.div`
  height: 100vh;
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
`;

const Main = () => {
  return (
    <SocketProvider>
      <Router>
        <PriceUpdateNotice />
        <GlobalConnectionStatus />
        <Routes>
          <Route path='/login' element={<Login />} />
          <Route
            path='/logout'
            element={
              <SimpleLayout>
                <Logout />
              </SimpleLayout>
            }
          />
          <Route path='/register' element={<Register />} />
          <Route path='/about-developer' element={<AboutDeveloper />} />
          <Route
            path='/feedback'
            element={
              <Layout>
                <Feedback />
              </Layout>
            }
          />
          <Route
            path='/privacy'
            element={
              <SimpleLayout selected='privacy'>
                <Privacy />
              </SimpleLayout>
            }
          />
          <Route path='/' element={<Home />} />
          <Route
            path='/terms'
            element={
              <SimpleLayout selected='terms'>
                <Terms />
              </SimpleLayout>
            }
          />
          <Route
            path='/app'
            element={
              <Layout>
                <App />
              </Layout>
            }
          />
          <Route
            path='/appointment/:appId'
            element={
              <Layout>
                <Appointment />
              </Layout>
            }
          />
          <Route
            path='/appointment/edit/:appId'
            element={
              <Layout>
                <AppointmentEditor />
              </Layout>
            }
          />
          <Route
            path='/appointment/quote/:appId'
            element={
              <BareLayout>
                <AppointmentQuote />
              </BareLayout>
            }
          />
          <Route
            path='/appointment/create'
            element={
              <Layout>
                <AppointmentCreator />
              </Layout>
            }
          />
          <Route
            path='/company/create'
            element={
              <Layout>
                <CompanyCreator />
              </Layout>
            }
          />
          <Route
            path='/company/edit/:companyId'
            element={
              <Layout>
                <CompanyEditor />
              </Layout>
            }
          />
          <Route
            path='/settings'
            element={
              <Layout>
                <Settings />
              </Layout>
            }
          />
          <Route
            path='/messages'
            element={
              <Layout>
                <Messages />
              </Layout>
            }
          />
        </Routes>
      </Router>
    </SocketProvider>
  );
};

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Main />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
